import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {get, min} from 'lodash';
import Highcharts from 'highcharts';
import {getPracticeBasedTitle} from "../utils";

export default function ({printable}) {

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);

    const graph_id = 'pam-domain-graph';
    const domain_data = dashboard_data.domain_data;
    const skill_data = dashboard_data.skill_data;

    useEffect(() => {
        if (domain_data) {
            draw();
        }
    }, [domain_data, skill_data]);

    if (domain_data === undefined) {
        return null;
    }

    function draw() {
        const graph = {
            chart: {
                type: 'bar',
                marginLeft: 230,
                height: 550
            },
            title: {
                text: getPracticeBasedTitle(dashboard).domain,
                style: {
                    fontWeight: 'bolder',
                    fontSize: '18px'
                }
            },
            xAxis: {
                categories: domain_data.categories,
                labels: {
                    style: {}
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Student Achievement'
                },
                labels: {
                    format: '{text}%'
                }
            },
            tooltip: {
                pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                bar: {
                    stacking: 'percent',
                    maxPointWidth: 60,
                },
                series: {
                    stacking: 'normal'
                }
            },
            series: domain_data.series,
            legend: {
                enabled: true,
                reversed: true
            },
            credits: {
                enabled: false
            }
        }

        if (printable) {
            graph.tooltip.enabled = false;
        }

        Highcharts.chart(graph_id, graph)
    }

    return (
        <div>
            <div id={graph_id} />
        </div>
    );
}
